import { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  CEO_THEME_STORAGE_KEY,
  DEFAULT_CEO_THEME,
  normalizeCEOTheme,
} from "./ceoThemes";
import "./ceoTheme.css";

const CEOThemeContext = createContext(null);

function readSavedTheme() {
  try {
    return normalizeCEOTheme(window.localStorage.getItem(CEO_THEME_STORAGE_KEY));
  } catch {
    return DEFAULT_CEO_THEME;
  }
}

export function CEOThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readSavedTheme);

  useEffect(() => {
    try {
      window.localStorage.setItem(CEO_THEME_STORAGE_KEY, theme);
    } catch {
      // Private browsing or disabled storage must not break the workspace.
    }
  }, [theme]);

  const value = useMemo(
    () => ({ theme, setTheme: (next) => setThemeState(normalizeCEOTheme(next)) }),
    [theme],
  );

  return (
    <CEOThemeContext.Provider value={value}>
      <div className="ceo-theme" data-ceo-theme={theme}>{children}</div>
    </CEOThemeContext.Provider>
  );
}

export function useCEOTheme() {
  const context = useContext(CEOThemeContext);
  if (!context) throw new Error("useCEOTheme must be used inside CEOThemeProvider");
  return context;
}
